<template>
  <h1>Einstellungen</h1>

  <DatabaseStatus />
</template>

<script lang="ts" setup>
  //#region Imports
  import DatabaseStatus from '@/components/Einstellungen/DatabaseStatus.vue';
  //#endregion
</script>
